import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const NotFoundHeading = styled.h1`
  font-size: 24px;
  margin-bottom: 16px;
`;

export const NotFoundMessage = styled.p`
  font-size: 18px;
`;
